// import { notification } from 'antd';
// const ToastMsg = (type, message, placement = "topRight") => {
    // notification[type]({
    //     type: type,
    //     message: message,
    //     style: {
    //         width: "35vw",
    //         borderLeft: `6px solid ${type === "warning" ? "#E28F12" : type === "error" ? "Red" : "#0E862A"}`,
    //         borderRadius: '10px 0px 0px 10px',
    //     },
    //     placement: 'topRight',
    // });

// export default ToastMsg;

import { message } from 'antd';
import { duration } from 'moment';

const ToastMsg = (type, messageText, id = 'data-id', placement = "topRight") => {
    // You can use the message API directly instead of notification
    const capType = type.charAt(0).toUpperCase() + type.slice(1); // Capitalize type (optional)

    const messageContent = {
        content: <span id='data-testId=alert-msg'>{messageText}</span>,
        duration: 3.5,
    }

    // Display the message based on the type
    if (type === "success") {
        message.success(messageContent); // Success message, duration 3.5 seconds
    } else if (type === "error") {
        message.error(messageContent); // Error message, duration 3.5 seconds
    } else if (type === "info") {
        message.info(messageContent); // Info message, duration 3.5 seconds
    } else if (type === "warning") {
        message.warning(messageContent); // Warning message, duration 3.5 seconds
    } else {
        message.open({
            type: capType,
            placement: placement,
            // content: messageText,
            // duration: 3.5,
            ...messageContent
        });
    }
}

export default ToastMsg;

